<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GAZ94M/tc-custom/9781504073219.jpg?1723836044115" alt="This image is the cover for the book Kindness of Strangers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kindness of Strangers
      </h1>
      <p class="bookDescription body article font2">
        <b>This novel about the dark past that haunts a seemingly happy household is “an intricate portrayal of love and loss, redemption and revenge” (Anne Coates, author of <i>Songs of Innocence</i>).</b><br/><br/>Helen, a widow, is desperate for a perfect family life and will do everything she can to get what she wants.<br/><br/>Martin, a veteran, is adrift and seemingly without hope. Can he ever win back his estranged family?<br/><br/>Charley, a pregnant teenager, is striking out on her own to create a new life for her unborn child—but her mother has other ideas.<br/><br/>When these three seemingly disparate lives connect, the past and the present collide to reveal secrets, lies, and just how far people are willing to go to hide the truth . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie Newman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3bb6427c